import { createSelector, createSlice } from '@reduxjs/toolkit'
import { apiBatchUpdateExercises } from '../api/api';

export const exercisesSlice = createSlice({
    name: 'exercises',
    initialState: {
        items: null,
        loading: false,
        error: null,
        showOnlyFavorites: false,
        distinctDays: [],
        maxOrder: null,
        apiEnabled: false
    },
    reducers: {
        setItems: (state, action) => {
            state.items = action.payload;
            state.loading = false;
            state.error = null;
            state.maxOrder = Math.max(...state.items.map((value, index) => value.order))
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
            state.loading = false;
        },
        update: (state, action) => {
            const updatedItem = action.payload
            const index = state.items.findIndex((element) => (element.id === updatedItem.id))
            state.items[index] = updatedItem
        },
        deleteItem: (state, action) => {
            const itemToDelete = action.payload;
            state.items = state.items.filter(item => item.id !== itemToDelete);
        },
        toggleShowOnlyFavorites: (state, action) => {
            state.showOnlyFavorites = !state.showOnlyFavorites
        },
        toggleFavorite: (state, action) => {
            const id = action.payload
            const index = state.items.findIndex((element) => (element.id === id))
            state.items[index].favorite = !state.items[index].favorite
        },
        addNew: (state, action) => {
            const newItem = action.payload
            state.items.push(newItem)
            state.maxOrder = Math.max(...state.items.map((value, index) => value.order))
        },
        swapExercises: (state, action) => {
            const current = action.payload.current
            const another = action.payload.another
            const currentIndex = state.items.findIndex((element) => (element.id === current.id))
            const anotherIndex = state.items.findIndex((element) => (element.id === another.id))
            const temp = state.items[currentIndex].order
            state.items[currentIndex].order = state.items[anotherIndex].order
            state.items[currentIndex].modified = Date.now()
            state.items[anotherIndex].order = temp
            state.items[anotherIndex].modified = Date.now()
        },
        fixExercisesOrder: (state, action) => {
            const day = action.payload.day
            const user = action.payload.user
            let orderCounter = 0;
            const updatedExercises = [];
            state.items.sort((a, b) => a.order - b.order).forEach((element) => {
                if (element.day === day) {
                    if (element.order !== orderCounter + 1) {
                        element.order = orderCounter + 1
                        element.modified = Date.now()
                        updatedExercises.push(element)
                    }
                    orderCounter++;
                }
            });

            apiBatchUpdateExercises(user, updatedExercises);
        },
        forgetExercises: (state, action) => {
            state.apiEnabled = false
            state.items = null
        },
        enableApi: (state, action) => {
            state.apiEnabled = true
        }
    },

});
const selectExerciseItems = (state) => state.exercises?.items || []
export const selectFavorites = createSelector(
    [selectExerciseItems],
    (items) => items.filter((value) => value.favorite === true)
)
export const { setItems, setLoading, setError, update, deleteItem, toggleShowOnlyFavorites, toggleFavorite, addNew, swapExercises, fixExercisesOrder, forgetExercises, enableApi } = exercisesSlice.actions
export default exercisesSlice.reducer;